<template>
    <div class="designerpage">

        <bowater-designer-question-door-range :fabricator="fabricator"
                                              v-model:target="door.attr.door_range"
                                              :reference_on="reference_on"
                                              :ranges="ranges"
                                              :defaults="defaults()"
                                              title="Choose a Door Range"></bowater-designer-question-door-range>

        <truedor-designer-question-secured-by-design
            :fabricator="fabricator"
            v-model:target="door.attr.secured_by_design"
        ></truedor-designer-question-secured-by-design>

        <div>
            <wb-designer-question-select-door :fabricator="fabricator"
                                              :secured-by-design="door.attr.secured_by_design"
                                              :door-range="door.attr.door_range"
                                              v-model:target="door.attr.slab"
                                              title="Choose Your Door Style"
            ></wb-designer-question-select-door>

        </div>

        <designer-question-frame-material :slab="door.attr.slab"
                                             :fabricator="fabricator"
                                             :secured-by-design="door.attr.secured_by_design"
                                             v-model:target="door.attr.frame_material"></designer-question-frame-material>

        <truedor-designer-question-select-frame-style
            v-show="!isSlabOnly"
            :fabricator="fabricator"
            :is-firedoor="is_firedoorrange"
            :type-range="door.attr.door_range"
            v-model:target="door.attr.frame_style"
            :frame-material="door.attr.frame_material"
        ></truedor-designer-question-select-frame-style>

        <spitfire-designer-question-colour-range
            title="Colour Ranges"
            :fabricator="fabricator"
            :slab="door.attr.slab"
            :type-range="door.attr.door_range"
            v-model:target="door.attr.colour_range"
        ></spitfire-designer-question-colour-range>

        <div class="row">
            <div class="col-sm">
                <div class="designeroption" data-designer-component-id="external_colour">

                    <h3>Choose Your External Door Colour</h3>

                    <wb-designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                               :door-range="door.attr.door_range"
                                                               :colour-range="door.attr.colour_range"
                                                               v-model:target="door.attr.external_colour"></wb-designer-question-door-colour-external>

                    <div class="stylesoption">
                        <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.external_colour"
                                                      title="External Door Colour"
                                                      v-model:target="door.attr.external_colour_ral"></designer-question-ral-colour>
                    </div>

                </div>
            </div>
            <div class="col-sm">
                <div class="designeroption" data-designer-component-id="door_colour_internal">

                    <h3>Choose Your Internal Door Colour</h3>

                    <wb-designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                               :door-range="door.attr.door_range"
                                                               :colour-range="door.attr.colour_range"
                                                               :external-colour="door.attr.external_colour"
                                                               v-model:target="door.attr.door_colour_internal"></wb-designer-question-door-colour-internal>

                    <div class="stylesoption">
                        <designer-question-ral-colour :fabricator="fabricator"
                                                      :colour-id="door.attr.door_colour_internal"
                                                      title="Internal Door Colour"
                                                      v-model:target="door.attr.door_colour_internal_ral"></designer-question-ral-colour>
                    </div>

                </div>
            </div>
        </div>

        <div class="row" v-show="!isSlabOnly">
            <div class="col-sm">
                <div class="designeroption" data-designer-component-id="frame_colour_external">

                    <h3>Choose Your External Frame Colour</h3>

                    <wb-designer-question-frame-colour-external :fabricator="fabricator"
                                                                :frame-material="door.attr.frame_material"
                                                                :slab="door.attr.slab"
                                                                :door-range="door.attr.door_range"
                                                                :colour-range="door.attr.colour_range"
                                                                v-model:target="door.attr.frame_colour_external"></wb-designer-question-frame-colour-external>

                    <div class="stylesoption">
                        <designer-question-ral-colour :fabricator="fabricator"
                                                      :colour-id="door.attr.frame_colour_external"
                                                      title="External Frame Colour"
                                                      v-model:target="door.attr.frame_colour_external_ral"></designer-question-ral-colour>
                    </div>

                </div>
            </div>
            <div class="col-sm">
                <div class="designeroption" data-designer-component-id="frame_colour_internal">

                    <h3>Choose Your Internal Frame Colour</h3>

                    <wb-designer-question-frame-colour-internal :fabricator="fabricator"
                                                                :frame-material="door.attr.frame_material"
                                                                :frame-colour-external="door.attr.frame_colour_external"
                                                                :slab="door.attr.slab"
                                                                :door-range="door.attr.door_range"
                                                                :colour-range="door.attr.colour_range"
                                                                v-model:target="door.attr.frame_colour_internal"></wb-designer-question-frame-colour-internal>

                    <div class="stylesoption">
                        <designer-question-ral-colour :fabricator="fabricator"
                                                      :colour-id="door.attr.frame_colour_internal"
                                                      title="Internal Frame Colour"
                                                      v-model:target="door.attr.frame_colour_internal_ral"></designer-question-ral-colour>
                    </div>

                </div>
            </div>
        </div>

        <div class="designeroption">
            <designer-question-hinge-side :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"></designer-question-hinge-side>
        </div>
        <div class="designeroption">
            <designer-question-opening-direction :fabricator="fabricator"
                                                 v-model:target="door.attr.opening_direction"></designer-question-opening-direction>
        </div>

        <div v-show="technical_should_show">
            <wb-designer-question-technical-profile :fabricator="fabricator"
                                                    :frame-colour-internal="door.attr.frame_colour_internal"
                                                    :frame-colour-external="door.attr.frame_colour_external"
                                                    :frame-material="door.attr.frame_material"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :door-range="door.attr.door_range"
                                                    :opening-direction="door.attr.opening_direction"
                                                    v-model:target="door.attr.profile"></wb-designer-question-technical-profile>
        </div>

        <div>
            <wb-designer-question-door-glass-laminated :fabricator="fabricator"
                                                       title="Laminated Glass:"
                                                       :slab="door.attr.slab"
                                                       :frame-style="door.attr.frame_style"
                                                       :side-panels="door.attr.side_panels"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :is-firedoor="is_firedoorrange"
                                                       v-model:target="door.attr.laminated_glass"></wb-designer-question-door-glass-laminated>
        </div>

        <div>
            <wb-designer-question-glass-design :fabricator="fabricator"
                                               v-model:target="door.attr.glass_design"
                                               :laminated-glass="door.attr.laminated_glass"
                                               :door-range="door.attr.door_range"
                                               :slab="door.attr.slab"></wb-designer-question-glass-design>

            <designer-question-glass-text v-model:target="door.attr.glass_text"
                                          :glass-design="door.attr.glass_design"></designer-question-glass-text>

            <truedor-designer-question-glass-colour-selector :fabricator="fabricator"
                                                             v-model:target="door.attr.glass_colours"
                                                             title="Choose Your Glass Colours"
                                                             :slab="door.attr.slab"
                                                             :glass-design="door.attr.glass_design"></truedor-designer-question-glass-colour-selector>
        </div>

        <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                   v-model:target="door.attr.glass_backing_design"
                                                   :slab="door.attr.slab"
                                                   :door-range="door.attr.door_range"
                                                   :glass-design="door.attr.glass_design"></wb-designer-question-glass-backing-design>

        <truedor-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                           v-model:target="door.attr.side_panels"
                                                           :door-range="door.attr.door_range"
                                                           :frame-style="door.attr.frame_style"
                                                           :frame-profile="door.attr.profile"
                                                           :frame-material="door.attr.frame_material"
                                                           :laminated-glass="door.attr.laminated_glass"
                                                           :frame-colour-internal="door.attr.frame_colour_internal"
                                                           :frame-colour-external="door.attr.frame_colour_external"
                                                           :secured-by-design="door.attr.secured_by_design"
                                                           :slab="door.attr.slab"
                                                           :measurements.sync="door.attr.measurements"></truedor-designer-question-select-frame-sidepanels>


        <div>
            <wb-designer-question-hardware-colour :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_colour"
                                                  :sbd="door.attr.secured_by_design"
                                                  :slab="door.attr.slab"
                                                  :door-range="door.attr.door_range"
                                                  :profile="door.attr.profile"
                                                  :opening-direction="door.attr.opening_direction"></wb-designer-question-hardware-colour>

            <wb-designer-question-hardware-handle :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_handle"
                                                  :slab="door.attr.slab"
                                                  :secured-by-design="door.attr.secured_by_design"
                                                  :opening-direction="door.attr.opening_direction"
                                                  :hardware-colour="door.attr.hardware_colour"
                                                  :door-range="door.attr.door_range"
                                                  :profile="door.attr.profile"></wb-designer-question-hardware-handle>

            <designer-question-hardware-handle-split-spindle
                v-show="technical_should_show" :fabricator="fabricator"
                v-model:target="door.attr.hardware_handle_split_spindle"
                :hardware-handle="door.attr.hardware_handle"
                :slab="door.attr.slab"
            ></designer-question-hardware-handle-split-spindle>

            <designer-question-hardware-handle-internal :fabricator="fabricator"
                                                        v-model:target="door.attr.hardware_handle_internal"
                                                        :slab="door.attr.slab"
                                                        :secured-by-design="door.attr.secured_by_design"
                                                        :opening-direction="door.attr.opening_direction"
                                                        :hardware-colour="door.attr.hardware_colour"
                                                        :door-range="door.attr.door_range"
                                                        :profile="door.attr.profile"
                                                        :handle-external="door.attr.hardware_handle"></designer-question-hardware-handle-internal>

        </div>
        <div>
            <wb-designer-question-hardware-escutcheon :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_escutcheon"
                                                      :slab="door.attr.slab"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                      :door-range="door.attr.door_range"
                                                      :profile="door.attr.profile"></wb-designer-question-hardware-escutcheon>

            <designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_escutcheon_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-escutcheon="door.attr.hardware_escutcheon"></designer-question-hardware-escutcheon-position>
        </div>
        <div>
            <truedor-designer-question-hardware-lock :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_lock"
                                                     :secured-by-design="door.attr.secured_by_design"
                                                     :hinge-side="door.attr.hinge_side"
                                                     :slab="door.attr.slab"
                                                     :frame-material="door.attr.frame_material"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :opening_direction="door.attr.opening_direction"
                                                     :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                     :door-range="door.attr.door_range"></truedor-designer-question-hardware-lock>

            <designer-question-hardware-cylinder v-show="technical_should_show" :fabricator="fabricator"
                                                 title="Choose Your Cylinder"
                                                 v-model:target="door.attr.hardware_cylinder"
                                                 :slab="door.attr.slab"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hardware-lock="door.attr.hardware_lock"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 :opening_direction="door.attr.opening_direction"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :door-range="door.attr.door_range"></designer-question-hardware-cylinder>
        </div>

        <div>
            <wb-designer-question-hardware-letterbox :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox"
                                                     :secured-by-design="door.attr.secured_by_design"
                                                     :slab="door.attr.slab"
                                                     :side-panels="door.attr.side_panels"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :door-range="door.attr.door_range"
                                                     :profile="door.attr.profile"
            ></wb-designer-question-hardware-letterbox>

            <designer-question-hardware-letterbox-cowl :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_letterbox_cowl"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-letterplate="door.attr.hardware_letterbox"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-letterbox-cowl>

            <designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_letterbox_pos"
                                                           :slab="door.attr.slab"
                                                           :side-panels="door.attr.side_panels"
                                                           :frame-id="door.attr.frame_style.frame_id"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-letterbox="door.attr.hardware_letterbox"
                                                           :door-range="door.attr.door_range"></designer-question-hardware-letterbox-position>
        </div>
        <div>
            <wb-designer-question-hardware-knocker :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_knocker"
                                                   :slab="door.attr.slab"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-spyhole="door.attr.hardware_spy_hole"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :door-range="door.attr.door_range"></wb-designer-question-hardware-knocker>

            <designer-question-hardware-knocker-position :fabricator="fabricator"
                                                         v-model:target="door.attr.hardware_knocker_pos"
                                                         :slab="door.attr.slab"
                                                         :frame-material="door.attr.frame_material"
                                                         :hardware-knocker="door.attr.hardware_knocker"
                                                         :door-range="door.attr.door_range"></designer-question-hardware-knocker-position>
        </div>

        <div>
            <wb-designer-question-hardware-spy-hole :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_spy_hole"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :glass-design="door.attr.glass_design"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :door-range="door.attr.door_range"></wb-designer-question-hardware-spy-hole>

            <designer-question-hardware-spy-hole-position :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_spy_hole_pos"
                                                          :slab="door.attr.slab"
                                                          :frame-material="door.attr.frame_material"
                                                          :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                          :door-range="door.attr.door_range"></designer-question-hardware-spy-hole-position>
        </div>

        <designer-question-numeral-colours
            :fabricator="fabricator"
            :question="'numeral_colours'"
            v-model:target="door.attr.numeral_colour"
            maintitle="Choose your numeral colour"
        ></designer-question-numeral-colours>

        <div class="designeroption">
            <designer-question-hardware-numerals :fabricator="fabricator"
                                                 v-model:target="door.attr.numerals"
                                                 :slab="door.attr.slab"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 :numeral-colour="door.attr.numeral_colour"
                                                 title="Numerals provided loose for you to finish your perfect door"></designer-question-hardware-numerals>
        </div>

        <div v-show="technical_should_show">
            <designer-question-hardware-hinge-dropdown
                :fabricator="fabricator"
                v-model:target="door.attr.hardware_hinge"
                :slab="door.attr.slab"
                :opening_direction="door.attr.opening_direction"
                :secured-by-design="door.attr.secured_by_design"
                :hardware-colour="door.attr.hardware_colour"
                :hinge-side="door.attr.hinge_side"
                :frame-material="door.attr.frame_material"
                :door-range="door.attr.door_range"
                maintitle="Hinge"
            ></designer-question-hardware-hinge-dropdown>
        </div>

        <div>
            <wb-designer-question-hardware-security-chain :fabricator="fabricator"
                                                          :secured-by-design="door.attr.secured_by_design"
                                                          v-model:target="door.attr.hardware_security_chain"
                                                          :hardware-colour="door.attr.hardware_colour"
                                                          :door-range="door.attr.door_range"></wb-designer-question-hardware-security-chain>
        </div>

        <!--        <div v-show="technical_should_show">-->
        <!--            <designer-question-restrictor :fabricator="fabricator"-->
        <!--                                          v-model:target="door.attr.restrictor"-->
        <!--                                          :opening-direction="door.attr.opening_direction"-->
        <!--                                          :slab="door.attr.slab"-->
        <!--            ></designer-question-restrictor>-->
        <!--            <div>-->
        <!--                <designer-question-closer :fabricator="fabricator"-->
        <!--                                          v-model:target="door.attr.closer"></designer-question-closer>-->
        <!--            </div>-->
        <!--        </div>-->

        <div v-show="technical_should_show && !isSlabOnly">
            <wb-designer-question-addons :fabricator="fabricator"
                                         v-model:target="door.attr.addons"
                                         :frame-profile="door.attr.profile"
                                         :frame-colour-internal="door.attr.frame_colour_internal"
                                         :frame-colour-external="door.attr.frame_colour_external"
            ></wb-designer-question-addons>

            <designer-question-technical-coupler :fabricator="fabricator"
                                                 v-model:target="door.attr.couplers"
                                                 :frame-profile="door.attr.profile"
                                                 :frame-combination="door.attr.frame_style.frame_id"
                                                 :title="'Select Coupler size'"
            ></designer-question-technical-coupler>
        </div>

        <div>
            <wb-designer-question-technical-threshold v-show="technical_should_show && !isSlabOnly"
                                                      :fabricator="fabricator"
                                                      title="Choose Your Threshold"
                                                      v-model:target="door.attr.threshold"
                                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                                      :frame-colour-external="door.attr.frame_colour_external"
                                                      :opening-direction="door.attr.opening_direction"
                                                      :frame-profile="door.attr.profile"
                                                      :door-range="door.attr.door_range"></wb-designer-question-technical-threshold>

        </div>

        <div class="designeroption" v-show="technical_should_show && !isSlabOnly">
            <h3>Select Any Required Sills</h3>
            <designer-question-technical-cill :fabricator="fabricator"
                                              v-model:target="door.attr.cill"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :opening-direction="door.attr.opening_direction"
                                              :frame-profile="door.attr.profile"
                                              :threshold="door.attr.threshold"
                                              :door-range="door.attr.door_range"
                                              :component_id="'cill'"
                                              :show_cill_horn_text="false"
            ></designer-question-technical-cill>

            <designer-question-technical-cill-measure
                v-if="sill_measure" :fabricator="fabricator"
                v-model:target="door.attr.cill_measure"
                title="Sill Length (mm)"
                :cill="door.attr.cill"
                :extra_text="'Please confirm your overall cill length including any horns'"
            ></designer-question-technical-cill-measure>

            <designer-question-technical-cill v-if="left_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.left_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Left Sidepanel Flag'"
                                              :component_id="'left_flag_cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill-measure
                v-if="left_flag_sill && left_sill_measure"
                :fabricator="fabricator"
                v-model:target="door.attr.left_flag_cill_measure"
                title="Left Sidepanel Flag Sill Length (mm)"
                :cill="door.attr.cill"
            ></designer-question-technical-cill-measure>

            <designer-question-technical-cill v-if="right_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.right_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Right Sidepanel Flag'"
                                              :component_id="'right_flag_cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill-measure
                v-if="right_flag_sill && right_sill_measure"
                :fabricator="fabricator"
                v-model:target="door.attr.right_flag_cill_measure"
                title="Right Sidepanel Flag Sill Length (mm)"
                :cill="door.attr.cill"
            ></designer-question-technical-cill-measure>
        </div>

        <div>
            <wb-designer-question-door-drip-colour v-show="technical_should_show" :fabricator="fabricator"
                                                   title="Choose A Weatherbar colour"
                                                   :external-colour="door.attr.external_colour"
                                                   v-model:target="door.attr.door_drip_colour"
                                                   :frame-profile="door.attr.profile"></wb-designer-question-door-drip-colour>

            <designer-question-technical-drainage v-show="technical_should_show" :fabricator="fabricator"
                                                  v-model:target="door.attr.drainage"
                                                  :cill="door.attr.cill"
                                                  :threshold="door.attr.threshold"></designer-question-technical-drainage>
        </div>

        <truedor-designer-question-measurements v-show="technical_should_show" title="Enter Your Required Measurements"
                                                :fabricator="fabricator"
                                                :slab="door.attr.slab"
                                                :external-colour="door.attr.external_colour"
                                                :internal-colour="door.attr.door_colour_internal"
                                                :frame-profile="door.attr.profile"
                                                :threshold="door.attr.threshold"
                                                :frame-id="door.attr.frame_style.frame_id"
                                                :side-panels="door.attr.side_panels"
                                                :addons="door.attr.addons"
                                                :couplers="door.attr.couplers"
                                                :cill="door.attr.cill"
                                                :hardware-lock="door.attr.hardware_lock"
                                                :hardware-hinge="door.attr.hardware_hinge"
                                                :hardware-handle="door.attr.hardware_handle"
                                                :hardware-knocker="door.attr.hardware_knocker"
                                                :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                :hardware-letterbox="door.attr.hardware_letterbox"
                                                :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                                :door-range="door.attr.door_range"
                                                :mdd="mdd"
                                                :technical_should_show="technical_should_show"
                                                :door-width-and-height-label="isSlabOnly ? 'Door Width x Height' : 'Frame Width x Height'"
                                                v-model:target="door.attr.measurements"></truedor-designer-question-measurements>

        <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
            <h3>Enter A Door Reference</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
                </div>
            </div>
        </div>
        <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control"
               value="Retail Door">

        <designer-question-notes v-model:target="door.attr.notes"></designer-question-notes>

        <designer-navigation
            v-if="show_navigation"
            :visible_designer_configurator_components="visible_designer_configurator_components"
            transition="designer-navigation"
        ></designer-navigation>

    </div>

</template>

<script type="text/ecmascript-6">
import DoorConfigurator from "../DoorConfigurator.vue";

export default {
    mixins: [
        DoorConfigurator,
    ],
    computed: {
        sill_measure() {
            return this.door.attr.cill !== 29 && this.door.attr.cill !== 4644;
        },
        left_sill_measure() {
            return this.door.attr.side_panels.left_flag_sill_id !== 29;
        },
        right_sill_measure() {
            return this.door.attr.side_panels.right_flag_sill_id !== 29;
        },
        isSlabOnly() {
            return this.door.attr.frame_material === 99;
        },
    },
    methods: {
        defaults() {
            return {
                1: {
                    "attr": {
                        "fabricator": 31,
                        "door_range": 1,
                        "frame_colour_external": 1,
                        "colour_range": 1,
                        "door_colour_internal": 1,
                        "external_colour": 1,
                        "frame_colour_internal": 1,
                        "hardware_colour": 37,
                        "hardware_handle": 1,
                        "hardware_hinge": 218,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 9,
                        "frame_style": {
                            "frame_id": 1,
                            "checkedPanels": []
                        },
                        "laminated_glass": 1,
                        "hardware_lock": 216,
                        "hardware_cylinder": 265,
                        "hardware_security_chain": 226,
                        "hardware_letterbox": 224,
                        "hardware_knocker": 225,
                        "hardware_suite": 3,
                        "hardware_spy_hole": 230,
                        "profile": 1,
                        "threshold": 2,
                        "side_panels": {
                            "left": 1,
                            "right": 1,
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "top_panel_glass_id": 5,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 5,
                            "right_panel_glass_id": 5,
                            "side_glass_text": {"text": "", "position": null},
                        },
                        "numerals": [
                            227,
                            227,
                            227,
                            227
                        ],
                        "addons": {
                            "left": {},
                            "right": {},
                            "top": {},
                            "bottom": {},
                        },
                        "cill": 29,
                        "drainage": 1,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "hardware_hinge_bolts": 232,
                        "hardware_handle_split_spindle": 219,
                        "hardware_decorative_handle": 228,
                        "glass_design": 1,
                        "glass_colours": null,
                        "frame_material": 1,
                        "couplers": {"sides": null, "top": null},
                        "numeral_colour": 10000,
                    }
                },
                2: {
                    "attr": {
                        "fabricator": 31,
                        "door_range": 2,
                        "frame_colour_external": 1,
                        "colour_range": 1,
                        "door_colour_internal": 1,
                        "external_colour": 1,
                        "frame_colour_internal": 1,
                        "frame_material": 1,
                        "hardware_colour": 37,
                        "hardware_handle": 1,
                        "hardware_hinge": 233,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 2009,
                        "frame_style": {"frame_id": 1, "checkedPanels": []},
                        "laminated_glass": 1,
                        "hardware_lock": 216,
                        "hardware_cylinder": 265,
                        "hardware_security_chain": 226,
                        "hardware_letterbox": 224,
                        "hardware_knocker": 225,
                        "hardware_suite": 3,
                        "hardware_spy_hole": 230,
                        "profile": 3963,
                        "threshold": 4362,
                        "side_panels": {
                            "left": 1,
                            "right": 1,
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "side_glass_text": {"text": "", "position": null}
                        },
                        "numerals": [227, 227, 227, 227],
                        "addons": {
                            "left": {},
                            "right": {},
                            "top": {},
                            "bottom": {},
                        },
                        "cill": 29,
                        "drainage": 1,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "hardware_hinge_bolts": 232,
                        "hardware_handle_split_spindle": 219,
                        "hardware_decorative_handle": 228,
                        "couplers": {"sides": null, "top": null},
                        "glass_design": 2,
                        "glass_backing_design": 3,
                        "glass_colours": null,
                        "numeral_colour": 10000,
                    }
                },
            };
        },
    }
}
</script>
